module.exports = "/_next/static/images/footer-bg-2d37fcddfa9c2bb814064072fee388ae.png";